import { Link } from "react-router-dom";
import { Lock, Mail } from "lucide-react";

/**
 * V25 — Friendly maintenance page shown when the global `tutor_portal_enabled`
 * toggle is OFF. Existing tutor accounts remain intact; only the public-facing
 * portal UI is gated.
 */
export default function TutorPortalUnavailable() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center" data-testid="tutor-portal-unavailable">
                <div className="w-14 h-14 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
                    <Lock className="w-6 h-6 text-amber-700" />
                </div>
                <h1 className="text-xl sm:text-2xl font-bold text-[#0F172A] mb-2" data-testid="tutor-maintenance-title">Tutor Portal is currently under maintenance</h1>
                <p className="text-sm text-slate-600 leading-relaxed" data-testid="tutor-maintenance-body">
                    Please try again later. Thank you for your patience.
                </p>
                <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-800">
                    Already have an account? Your data and progress are safe — the portal will be back shortly.
                </div>
                <div className="mt-6 flex flex-col items-center gap-2 text-sm">
                    <a href="mailto:anandhometutorials@gmail.com" className="inline-flex items-center gap-2 text-[#1E3A8A] hover:underline" data-testid="tutor-portal-contact-email">
                        <Mail className="w-4 h-4" /> anandhometutorials@gmail.com
                    </a>
                    <a href="mailto:info@anandtutorials.com" className="inline-flex items-center gap-2 text-[#1E3A8A] hover:underline" data-testid="tutor-portal-contact-email-business">
                        <Mail className="w-4 h-4" /> info@anandtutorials.com
                    </a>
                    <Link to="/" className="text-xs text-slate-500 hover:text-slate-700 mt-2" data-testid="tutor-portal-back-home">← Back to anandtutorials.com</Link>
                </div>
            </div>
        </div>
    );
}
